import React, { useMemo } from 'react'
import { Addresses } from '@homepages/shared/constants/aboutUs'
import {
  colorLightRed,
  colorTheme,
  colorWhite,
} from '@homepages/shared/styles/variables'
import Img from 'gatsby-image'

import Layout from '../components/LayoutNew'
import SEO from '../components/seo'
import HomeSection3 from '../containers/HomeSection3'

import './contact_us.scss'
import { graphql, useStaticQuery } from 'gatsby'

const ContactPage = () => {
  const { landmarkBuildings } = useStaticQuery(graphql`
    query {
      landmarkBuildings: allFile(
        filter: { relativePath: { glob: "contactUs/map/**/*" } }
      ) {
        nodes {
          name
          childImageSharp {
            fluid(maxWidth: 368, maxHeight: 200, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `)
  const landmarkMaps = useMemo(() => {
    if (landmarkBuildings && landmarkBuildings.nodes) {
      let res = []
      Addresses.forEach(addr => {
        const landmarkMap = landmarkBuildings.nodes.find(
          landmarkMap => addr.contactUs.localImgKey === landmarkMap.name
        )
        if (landmarkMap) {
          res.push({
            ...landmarkMap,
            ...addr,
          })
        } else {
          console.warn('localImgKey和图片名称不相符')
        }
      })
      return res
    }

    return []
  }, [landmarkBuildings])
  return (
    <Layout
      className="contact-page"
      headerBackground={colorWhite}
      fontColor={colorTheme}
    >
      <SEO
        title="联系我们"
        description="再惠总部位于上海，在全国16地设有分公司"
      />
      <div className="contact-us">
        <div className="head">
          <div className="head-info">
            <div className="head-info-title">联系我们</div>
            <div className="head-info-desc">
              再惠支持团队为您服务，您可通过邮件和电话形式进行咨询
            </div>
            <div className="head-info-contact">
              <i className="head-info-contact-icon iconfont z-icon_mail"></i>
              <a
                className="head-info-contact-detail"
                href="mailto:marketing@kezaihui.com"
              >
                marketing@kezaihui.com
              </a>
            </div>
            <a className="head-info-contact last" href="tel:021-60523213">
              <i className="head-info-contact-icon iconfont z-icon_phone"></i>
              <div className="head-info-contact-detail">021-60523213</div>
            </a>
          </div>
          <img
            src={require('@homepages/zaihui/src/images/contactUs/banner.jpg')}
            className="head-img"
          ></img>
        </div>

        {/* <div className="address">
          <h3>公司地址</h3>
          <div className="address-list">
            {landmarkMaps.map((item, index) => (
              <div className="item" key={index}>
                <a href={item.contactUs.uri} target="blank">
                  <div className="banner">
                    <Img fluid={item.childImageSharp.fluid} alt={item.name} />
                  </div>
                </a>
                <div className="info">
                  <div className="info-name">{item.name}</div>
                  <div className="info-detail">{item.address}</div>
                  <a href={`tel:${item.phone}`} className="info-tel">
                    {item.phone}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div> */}
      </div>
      <HomeSection3 />
    </Layout>
  )
}

export default ContactPage
